import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import snakeCaseKeys from 'snakecase-keys'
const requestService = new RequestService()

export class RegistrationCardsRequests {
  postDocumentScan (guestId, countryCode, cardType, documentImageFront, documentImageBack) {
    const route = ServerDirections.REGISTRATION_CARDS_DOCUMENT_SCAN.replace('{guestId}', guestId)
    const method = 'post'
    const multipart = true
    function map (data) {
      return data
    }

    var body = new FormData()
    body.append('country_code', countryCode)
    body.append('card_type', cardType)
    if (documentImageFront !== null) {
      const frontSplitName = documentImageFront.name ? documentImageFront.name.split('.') : 'DocumentFront'
      documentImageFront = new File([documentImageFront], `front.${ frontSplitName[frontSplitName.length - 1] }`, { type: documentImageFront.type })
      body.append('document_image_front', documentImageFront)
    }

    if (documentImageBack !== null) {
      const backSplitName = documentImageBack.name ? documentImageBack.name.split('.') : 'DocumentBack'
      documentImageBack = new File([documentImageBack], `back.${ backSplitName[backSplitName.length - 1] }`, { type: documentImageBack.type })
      body.append('document_image_back', documentImageBack)
    }

    return requestService.makePromise(route, method, { body, multipart }, map)
  }

  get (guestId) {
    const route = ServerDirections.REGISTRATION_CARDS.replace('{guestId}', guestId)
    const method = 'get'
    function map (data) {
      return data
    }

    return requestService.makePromise(route, method, { disableStatusHandling: { 404: true } }, map)
  }

  post (guestId, verifiedData) {
    const route = ServerDirections.REGISTRATION_CARDS_DOCUMENT.replace('{guestId}', guestId)
    const method = 'post'
    function map (data) {
      return data
    }

    var body = snakeCaseKeys(verifiedData)
    return requestService.makePromise(route, method, { body }, map)
  }

  postContact (guestId, body) {
    const route = ServerDirections.REGISTRATION_CARDS_CONTACT.replace('{guestId}', guestId)
    const method = 'post'
    function map (data) {
      return data
    }
    body = snakeCaseKeys(body)

    return requestService.makePromise(route, method, { body }, map)
  }

  postSignature (guestId, signature, checkboxes) {
    const route = ServerDirections.REGISTRATION_CARDS_SIGNATURE.replace('{guestId}', guestId)
    const method = 'post'
    function map (data) {
      return data
    }
    var body = new FormData()
    body.append('signature', signature)
    body.append('checkboxes', JSON.stringify(snakeCaseKeys(checkboxes)))

    const multipart = true

    return requestService.makePromise(route, method, { body, multipart }, map)
  }

  getTosSignature (fileId) {
    const route = ServerDirections.REGISTRATION_CARDS.replace('{fileId}', fileId)
    const method = 'get'
    function map (data) {
      return data
    }

    return requestService.makePromise(route, method, { }, map)
  }

  getFile (guestId, fileId) {
    const route = ServerDirections.REGISTRATION_CARDS_FILE.replace('{guestId}', guestId).replace('{fileId}', fileId)
    const method = 'get'
    function map (data, headers) {
      const type = headers.map['content-type']
      var bytes = new Uint8Array(data)
      var binary = bytes.reduce((data, b) => data += String.fromCharCode(b), '') // eslint-disable-line
      return 'data:' + type + ';base64,' + btoa(binary)
    }

    return requestService.makePromise(route, method, { responseType: 'arraybuffer', disableStatusHandling: { 404: true, 403: true } }, map)
  }
}
